module.exports = __webpack_public_path__ + "static/media/alerts.31924800.png";